import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";

import { Button } from "@/components/ui/button";

const RouteErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const isResponseError = isRouteErrorResponse(error);
  const message = isResponseError
    ? error.statusText || String(error.data)
    : error instanceof Error
      ? error.message
      : "예상치 못한 오류가 발생했습니다.";

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="max-w-md text-center">
        <p className="text-lg font-medium text-red-600">
          {isResponseError ? `${error.status} 오류` : "문제가 발생했습니다."}
        </p>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>
        <Button className="mt-4" onClick={() => navigate("/home")}>
          홈으로 돌아가기
        </Button>
      </div>
    </div>
  );
};

export default RouteErrorBoundary;
